const MuiCardActions = {
	styleOverrides: {
		root: {
			padding: "16px 24px",
		},
	},
};
export default MuiCardActions;
